import update, { extend } from 'immutability-helper';
import { reduxLoggerPatch, reduxLoggerState } from 'src/libs/logger';

extend('$none', (nothing, original) => {
	return original;
});

export function applyPatch(prevState: any, patch: any, type: string) {
	try {
		reduxLoggerPatch(type, patch);
		const newState = update(prevState, patch);
		reduxLoggerState(prevState, newState);
		return newState;
	} catch (ex) {
		console.error(ex);
		return prevState;
	}
}
